import { Activity } from '../activity';
import { ChallengeItem } from '../challenge';
import { AscFile } from '../common-types';
import { Caption } from '../utility-types';
import { ModuleSurvey } from './module-survey';

export interface Module {
  id: string;
  moduleNumber?: number;
  title: string;
  description?: string;
  lengthInMinutes: number;
  completed?: boolean;
  started?: boolean;
  skillId?: string;
  totalModulesInSkill?: number;
  coverImageUrl?: string;
  videoCompleted?: boolean;
  videoPrompt?: string;
  videoUrl?: string;
  videoCaptions?: Caption[];
  survey?: ModuleSurvey;
  banner?: {
    color: string;
    variant: number;
    face: string;
    text: string;
    secondText: string;
  };
  digDeeper?: {
    title?: string;
    description?: string;
    additionalFilesLabel?: string;
    files?: AscFile[];
  };
  reflection?: {
    question?: string;
    numberOfResponses?: number;
    submitButtonText?: string;
    response?: string[];
  };
  challenge?: ChallengeItem;
  activities?: {
    id: string;
    type: Activity['type'];
    isAttempted?: boolean;
  }[];
  note?: {
    id: string;
    body: string;
    updatedAt: string;
  };
}

export interface UsefulTipsContent {
  apps?: {
    title: string;
    items: {
      id: string;
      androidLink?: string;
      iosLink?: string;
      title: string;
      logoUrl: string;
      description: string;
      ios?: boolean;
      free?: boolean;
      url?: string;
      android?: boolean;
    }[];
  };
  movies?: {
    title: string;
    items: {
      id: string;
      url: string;
      title: string;
      coverImageUrl: string;
      duration: string;
      genre: string;
    }[];
  };
  youtubeVideos?: {
    title: string;
    items: {
      id: string;
      url: string;
      title: string;
      coverImageUrl: string;
      duration: string;
      channelProfilePicture: string;
      channelName: string;
    }[];
  };
  podcasts?: {
    title: string;
    items: {
      id: string;
      url: string;
      title: string;
      logoUrl: string;
      author: string;
    }[];
  };
  books?: {
    title: string;
    items: {
      id: string;
      url: string;
      title: string;
      coverImageUrl: string;
      author: string;
      category: string;
    }[];
  };
}

export const ModuleType = {
  SKILL: 'skill',
  ENTREPRENEURSHIP: 'entrepreneurship',
  INTERNSHIP: 'internship',
} as const;

export type ModuleType = (typeof ModuleType)[keyof typeof ModuleType];
